<template>
  
    <v-simple-table>
      <thead>
        <tr>
          <th colspan="5">
           
          </th>
          <th colspan="1" >
            <v-switch
              v-model="selectAllSymptomScreening"
               label="Symptoms: No/Yes"
              dense
              hide-details
            ></v-switch>
          </th>
          <th colspan="1" >
            <v-switch
              v-model="selectAllRefer"
              label="Refer: No/Yes"
              dense
              hide-details
            ></v-switch>
          </th>
        </tr>
        <tr>
          <th>No</th>
          <th>Name</th>
          <th>Age</th>
          <th>Sex</th>
          <th>Type</th>
          <th>Symptom Screening</th>
          <th>Refer</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="updatedPresumptiveData.case_found_at">
          <td>1</td>
          <td>{{ updatedPresumptiveData.name }}</td>
          <td>{{ updatedPresumptiveData.dob }}</td>
         
          <td>Patient</td>
          <td>
            <v-btn
              @click="goToFollowUpSaveForm"
              icon
              color="orange darken-1"
              class="mr-2 white--text"
              depressed
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr
          v-else
          v-for="(item, index) in updatedPresumptiveData"
          v-bind:key="item.id"
          v-show="!item.reg_unique_code && checkIfDuplicate(item)"
        >
          <td>{{ index + 1 }}</td>
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.age }}
          </td>
          <td>{{ item.sex=="2"?"Female":"Male" }}</td>
          <td>
            <span
              v-if="item.relationship == 1 && item.referral_from_id == null"
            >
              Family Member
            </span>
            <span
              v-else-if="
                item.relationship == 1 && item.referral_from_id != null
              ">
            Family Member
            </span>
            <span
              v-else-if="
                item.case_found_at == 3 && item.relationship == 3
              "
            >
            Close Contact
            </span>
            <!-- <span v-else-if="item.case_found_at == 5">Follow Up (Refer)</span> -->
            <!-- <span v-else-if="item.existing_presumptive_id">Refer</span> -->
            <span v-else> Close Contact </span>
        </td>
         
          <td>
              <v-radio-group class="my-2" v-model="item.symptom_screening" hide-details dense row >
                <v-radio label="Yes" value="2"></v-radio>
                <v-radio label="No" value="1"></v-radio>
              </v-radio-group>
          </td>
          <td>
              <v-radio-group class="my-2"  v-model="item.refer" hide-details dense row :disabled="item.symptom_screening != '2'" >
                <v-radio label="Yes" value="2" ></v-radio>
                <v-radio label="No" value="1"></v-radio>
              </v-radio-group>
          </td>
         
        </tr>
   
        <tr>
          <td colspan="5"> Total </td>
          <td>
            <div class="inline-flex">
              <p>Male : <b class="total">{{ totalMales  }} </b></p>
              <p>Female : <b class="total">{{ totalFemales  }} </b></p>  
            </div>
          </td>
          <td>
            <div class="inline-flex">
              <p >Refer Male : <b class="total">{{totalReferMales}}</b></p>
              <p>Refer Female : <b class="total">{{ totalReferFemales }}</b></p>
            </div>
           
          </td>
        </tr>
        
      </tbody>
    </v-simple-table>
  

   
  </template>
  
  <script>
  import { mapState } from "vuex";
  
  export default {
    
    components: {
    },
    props: {
      updatedPresumptiveData: {
      type: Object,
    },

    },
   
    computed: {
      ...mapState("Presumptive", ["presumptiveData"]),
      ...mapState("Patient", ["patient"]),

      totalMales() {
        return  this.updatedPresumptiveData.filter(item => item.sex === '1' && item.symptom_screening === '2').length;    
      },

      totalFemales() {
        return this.updatedPresumptiveData.filter(item => item.sex === '2' && item.symptom_screening === '2').length;  
      },

      totalReferMales() {
        return this.updatedPresumptiveData.filter(item => item.sex === '1' && item.refer === '2').length;
      },

      totalReferFemales() {
        return this.updatedPresumptiveData.filter(item => item.sex === '2' && item.refer === '2').length;      
      },
   
    },

    data() {
    return {
        items:this.updatedPresumptiveData,
        selectAllRefer: false, 
        selectAllSymptomScreening:true,
      };
    },

    watch: {
      items: {
        deep: true,
        handler(newItems) {
          newItems.forEach((item) => {
            if (item.symptom_screening == '1') {
              item.refer = '1'; 
            }
          });
        },
      },
      selectAllRefer(newValue) {
        this.updatedPresumptiveData.forEach((item) => {
          if (item.symptom_screening === '2') {
            item.refer = newValue ? '2' : '1';
          }
        });
      },
      selectAllSymptomScreening(newValue) {
        this.updatedPresumptiveData.forEach((item) => {
          item.symptom_screening = newValue ? '2' : '1'; 
        });
      },
    },
   
    methods: {
      
      checkIfDuplicate(item) {
        var isShow = true;
        if (item.existing_presumptive == 2 && item.confirm == 1) {
          this.presumptiveData.forEach((element) => {
            if (element.id == item.existing_presumptive_id) {
              isShow = false;
            }
          });
        }
        return isShow;
      },
      
      calculateTotalMales(){
       return  this.updatedPresumptiveData.filter(item => item.sex === '1' && item.symptom_screening === '2').length;
      },
      calculateTotalFemales(){
       return  this.updatedPresumptiveData.filter(item => item.sex === '2' && item.symptom_screening === '2').length;
      },
      calculateTotalReferMales(){
       return  this.updatedPresumptiveData.filter(item => item.sex === '1' && item.refer === '2').length;
      },
      calculateTotalReferFemales(){
       return  this.updatedPresumptiveData.filter(item => item.sex === '2' && item.refer === '2').length;
      }
      
    },
  };
  </script>
  
  <style>
  .total{
    font-size: 1.1em;
  }
  .inline-flex {
    display: flex;
    gap: 8px; 
}
</style>
  